import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import { SubCategoryDTO, CategoryDTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';

@Injectable()
export class subcategoryService implements OnInit {
    public Source: LocalDataSource;

    constructor(private http: HttpClient, private notifcationService: NotificationService) {
        this.Source = new LocalDataSource();
    }

    getSubcategories(): any {
       return this.http.get<SubCategoryDTO[]>(environment.apiUrl + "/SubCategory").pipe(
            catchError(this.handleError)
        );
    }

    addSubCategory(subCategoryDTO: SubCategoryDTO) {
        return this.http.post(environment.apiUrl + "/SubCategory", subCategoryDTO).subscribe(
            data => {
                this.notifcationService.showSuccess("SubCategory", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("SubCategory", "ajout avec success");
                console.error(error);
            }
        );



    }

    updateSubCategory(SubCategory: SubCategoryDTO) {

        return this.http.put(environment.apiUrl + "/SubCategory", SubCategory).subscribe(
            data => {
                this.notifcationService.showSuccess("SubCategory", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("SubCategory", "ajout avec success");
                console.error(error);
            }
        );
    }
    
    getSubCategory(idCategory: number) {
        return this.http.get<SubCategoryDTO[]>(environment.apiUrl + "/SubCategory/" + idCategory)
            .pipe(
                catchError(this.handleError)
            );
    }

    deleteSubCategory(idSubCategory: number) {
        this.http.delete<any>(environment.apiUrl + "/SubCategory/" + idSubCategory).subscribe(
            data => {
                this.notifcationService.showSuccess("SubCategory", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("SubCategory", "suppression avec success");
                console.error(error);
            }
        );
    }



    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
    };



}